import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './search-bar.html',
  styleUrl: './search-bar.scss',
})
export class SearchBar {
  @Input() isAdvancedSearchAvailable: boolean = true
  @Input() value: string = '';
  @Output() search = new EventEmitter<string>();
  @Output() toggleAdvanced = new EventEmitter<void>();

  onSearchChange(event: Event): void {
    this.value = (event.target as HTMLInputElement).value;
  }

  onSearch(): void {
    this.search.emit(this.value);
  }

  onClear(): void {
    this.value = '';
    this.search.emit('');
  }

  onToggleAdvanced(): void {
    this.toggleAdvanced.emit();
  }
}
